
import { defineComponent, inject } from 'vue';
import { EXTERNAL_CONNECT_URL, ISignupFormState } from '../signupFlow';
import { PhArrowLeft, PhArrowRight, PhArrowSquareOut, PhWarning } from '@phosphor-icons/vue';

export default defineComponent({
    name: 'StepUseDitto',
    components: { PhArrowLeft, PhArrowRight, PhArrowSquareOut, PhWarning },
    emits: ['back', 'connect', 'tell-admin'],
    setup() {
        const form = inject('signupForm') as ISignupFormState;
        return { form, externalConnectUrl: EXTERNAL_CONNECT_URL };
    }
});
